import(/* webpackMode: "eager" */ "/home/runner/work/finn-auto-ui-frontend/finn-auto-ui-frontend/apps/finn-auto-ui/app/[lang]/error.tsx");
